import type { MouseEvent } from 'react';

/**
 * A modifier or non-primary click already means something to the browser — a new tab, a new
 * window, a download. Intercepting it would take that away, so only the plain click is ours.
 */
function isBrowserHandledClick(event: MouseEvent): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
}

export { isBrowserHandledClick };
